<template>
    <span>
        <v-navigation-drawer app v-model="drawer" class="brown lighten-2" dark disable-resize-watcher>
            <img v-if="slug != null" @click="fnAtualizar" :src="atualizar" class="atualizar" />
            <v-container grid-list-lg>
                <v-layout row wrap class="meal-plans">
                    <v-dialog v-model="dialog" v-if="dialog" persistent max-width="290">
                        <v-card>
                            <v-card-title class="headline" style="padding-bottom:0;">{{title}}</v-card-title>
                            <v-card-text style="padding-top:0;">{{body}}</v-card-text>
                            <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="green darken-1" flat @click="closeDialog">OK</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-layout>
            </v-container>
            <div class="profile">
                <!-- <img :src="urlImg" @click="meuPerfil" /> -->
                <div class="img" v-bind:style="{ 'background-image': 'url(' + urlImg + ')' }" ></div>
                <h3>{{nome}}</h3>
                <div v-if="isAuthenticated || setIsAuthenticated" class="div-logout">
                    <!--v-btn flat to="/about">PROFILE</v-btn-->
                    <v-btn class="logout" outline color="white" @click="logout" data-cy="logout">Sair</v-btn>
                </div>
            </div>
            <br />
            <div v-if="alertaVencimentoMensal && cookieMensalidade != 'pago'" class="alert-mensalidade">
                <button type="button" aria-hidden="true" @click="fecharAlertaVencimento" class="close">×</button>
                <span>
                    <b> Aviso! </b><br />
                    {{msgVencimentoAlerta}}
                    <!-- <a class="fecharAviso" v-if="alertaVencimentoMensal" @click="alertaVencimentoMensal = false">Ocultar aviso</a> -->
                </span>
            </div>
            
            <!-- <v-alert v-if="alertaVencimentoMensal"
                :value="true"
                color="warning"
                icon="priority_high"
                outline
                >
                {{msgVencimentoAlerta}}
                    <a class="fecharAviso" v-if="alertaVencimentoMensal" @click="alertaVencimentoMensal = false">Ocultar aviso</a>
            </v-alert> -->
            <v-list>
                <!-- <template v-for="(item, index) in items">
                    <v-list-tile :to="item.href" :key="index">
                        <v-list-tile-content>
                            <a flat >{{item.title}}</a>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider :key="`divider-${index}`"></v-divider>
                </template> -->
                <template>
                    <v-list-tile v-if="perfil == 1" to="/cadastro-usuarios-adicionar-admin">
                        <v-list-tile-content>
                            <a flat >Usuario Add Admin</a>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="perfil == 1"></v-divider>
                    <v-list-tile v-if="perfil == 1" to="/cadastro-usuarios-adicionar-escola">
                        <v-list-tile-content>
                            <a flat >Usuario Add Escola</a>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="perfil == 1"></v-divider>
                    <v-list-tile v-if="perfil == 2" to="/cadastro-usuarios-listagem">
                        <v-list-tile-content>
                            <a flat >Usuarios</a>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="perfil == 2"></v-divider>
                    <v-list-tile v-if="perfil == 2 || perfil == 3" to="/criar-post">
                        <v-list-tile-content>
                            <a flat >Novo Post</a>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="perfil == 2 || perfil == 3"></v-divider>
                    <v-divider v-if="perfil == 2"></v-divider>
                    <!-- <v-list-tile v-if="perfil == 2 || perfil == 3" to="/eventos-listagem">
                        <v-list-tile-content>
                            <a flat >Eventos</a>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="perfil == 2 || perfil == 3"></v-divider> -->
                    <v-list-tile to="/display-cardapio">
                        <v-list-tile-content>
                            <a flat >Cardapio</a>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile v-if="perfil == 4 || perfil == 5 || perfil == 6" to="/lembrete-medicacao-listagem">
                        <v-list-tile-content>
                            <a flat >Medicamentos</a>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="perfil == 4 || perfil == 5 || perfil == 6"></v-divider>
                    <v-list-tile v-if="perfil == 4 || perfil == 5" to="/meus-alunos">
                        <v-list-tile-content>
                            <a flat >Meus Alunos</a>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="perfil == 4 || perfil == 5"></v-divider>
                    <v-list-tile v-if="perfil == 4 || perfil == 5" to="/resumo-diario-listagem">
                        <v-list-tile-content>
                            <a flat >Diario</a>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="perfil == 4 || perfil == 5"></v-divider>
                    <v-list-tile v-if="perfil == 2 || perfil == 3 || perfil == 6" to="/ocorrencias-listagem">
                        <v-list-tile-content>
                            <a flat >Ocorrências</a>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="perfil == 2 || perfil == 3"></v-divider>
                    <v-list-tile v-if="perfil == 2 || perfil == 3" to="/turmas-listagem">
                        <v-list-tile-content>
                            <a flat >Turmas</a>
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider v-if="perfil == 2 || perfil == 3 || perfil == 4 || perfil == 5 || perfil == 6"></v-divider>
                    <v-list-tile v-if="perfil == 2 || perfil == 3 || perfil == 4 || perfil == 5 || perfil == 6" to="/enquete-listagem">
                        <v-list-tile-content>
                            <a flat >Enquetes</a>
                        </v-list-tile-content>
                    </v-list-tile>
                    
                </template>
                <div v-if="exibirAlertaMedicacao" @click="goToMedicamentos" class="alertaMedicacao">
                    <img :src="medicamento" />
                    <label>Você possuir alerta de medicação.</label><br />
                    <b>Clique aqui para visualizar!</b>
                    
                </div>
            </v-list>
            <!-- <template>
                <v-layout>
                    <v-flex xs12 sm6 offset-sm3>
                    <v-card>
                        <v-container grid-list-sm fluid>
                        <v-layout row wrap>
                            <v-flex
                            v-for="n in 9"
                            :key="n"
                            xs4
                            d-flex
                            >
                            <v-card flat tile class="d-flex">
                                <v-img
                                :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"
                                :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
                                aspect-ratio="1"
                                class="grey lighten-2"
                                >
                                <template v-slot:placeholder>
                                    <v-layout
                                    fill-height
                                    align-center
                                    justify-center
                                    ma-0
                                    >
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-layout>
                                </template>
                                </v-img>
                            </v-card>
                            </v-flex>
                        </v-layout>
                        </v-container>
                    </v-card>
                    </v-flex>
                </v-layout>
            </template> -->
        </v-navigation-drawer>
        <v-toolbar app color="brown darken-4" dark>
            <v-toolbar-side-icon v-if="slug != null" class="hidden-md-and-up" @click="drawer = !drawer"></v-toolbar-side-icon>
            
            <router-link to="/">
                <!-- <v-toolbar-title data-cy="titleBtn">{{appTitle}}</v-toolbar-title> -->
                <v-toolbar-title data-cy="titleBtn"> <img src="@/assets/site/img/logo.png" alt="logo"></v-toolbar-title>
            </router-link>
            <span v-if="slug != null" class="qtdMensagens">({{qtdNotificacoes}})</span><img v-if="slug != null" @click="goToMensagens" :src="mensagens" class="mensagens" />
            <!--v-btn flat class="hidden-sm-and-down nav-menu" to="/menu" data-cy="menuBtn">Menu</v-btn-->
            <v-spacer class="hidden-sm-and-down"></v-spacer>
            <div v-if="!isAuthenticated" class="hidden-sm-and-down">
                <v-btn flat to="/sign-in" data-cy="signinBtn">SIGN IN</v-btn>
                <!--v-btn color="brown lighten-3" to="/join" class="nav-join" data-cy="joinBtn">JOIN</v-btn-->
            </div>
            
        </v-toolbar>
        <v-dialog v-model="dialogVencimento" class="vencimento" persistent min-width="99%" max-width="99%">
            <v-card>
                <a class="fecharComentario" @click="dialogVencimento = false">x</a>
                <v-card-title class="headline" style="padding-top:0">Mensalidade escolar</v-card-title>
                
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                
                <v-btn block color="primary"  large flat @click="lembrarDepois">Lembrar depois</v-btn>
                <v-btn block color="green darken-1" large flat @click="estaPago">Está pago!</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
    
    
</template>


<script>

import firebase,{ storage } from 'firebase';
import { userProperties, pushProperties, globalProperties, cache } from '@/global.js';

import medicamento from '../assets/iconfinder_medical_pot_pills_38714.png';
import mensagens from '../assets/iconfinder_chat-80px_510931.png';
import atualizar from '../assets/ic-atualizar.png';

export default {
    name: 'AppNavigation',
    data() {
        return {
            appTitle: 'InClass',
            dialogVencimento: false,
            cookieMensalidade: $.cookie('mensalidade'),
            dialog: false,
            drawer: false,
            urlImg: null,
            nome: null,
            slug: null,
            perfil: null,
            exibirAlertaMedicacao: false,
            itemsMedicacao: [],
            alertaVencimentoMensal: false,
            msgVencimentoAlerta: "",
            setIsAuthenticated: false, // customização minha para ler o session storage,
            title: false,
            body: false,
            medicamento: medicamento,
            mensagens: mensagens,
            atualizar: atualizar,
            qtdNotificacoes: 0,
            items: [
                //{ title: 'Sign In', href: '/sign-in' },
                //{ title: 'Join', href: '/join' },
                { title: 'Usuarios', href: '/cadastro-usuarios-listagem' },
                //{ title: 'Usuario Add', href: '/cadastro-usuarios-adicionar' },
                { title: 'Usuario Add Admin', href: '/cadastro-usuarios-adicionar-admin' },
                { title: 'Usuario Add Escola', href: '/cadastro-usuarios-adicionar-escola' },
                { title: 'Novo Post', href: '/criar-post' },
                { title: 'Comunicados', href: '/comunicados-listagem' }
            ]
        };
    },
    computed: {
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        }
    },
    methods: {
        fecharAlertaVencimento(){
            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': 'menu',
                'event_label': 'fechar alerta de vencimento mensal'//,
                //'value': '<value>'
            });

            this.alertaVencimentoMensal = false;
            this.dialogVencimento = true;
        },
        lembrarDepois(){
            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': 'menu',
                'event_label': 'lembrar depois'//,
                //'value': '<value>'
            });

            this.dialogVencimento = false;
        },
        estaPago(){
            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': 'menu',
                'event_label': 'esta pago'//,
                //'value': '<value>'
            });

            this.dialogVencimento = false;
            // set cookie
            $.cookie("mensalidade", "pago", { expires: 7 });
        },
        logout() {
            
            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': 'menu',
                'event_label': 'sair'//,
                //'value': '<value>'
            });

            // this.$ga.event({
            //     eventCategory: 'menu',
            //     eventAction: 'clicou',
            //     eventLabel: 'sair'//,
            //     //eventValue: 123
            // })

            userProperties.loaded = false,
            userProperties.email = null;
            userProperties.perfil = null,
            userProperties.slug = null,
            userProperties.extensao = null,
            userProperties.nome = null,
            userProperties.escolaID = null

            localStorage.removeItem("setIsAuthenticated");
            localStorage.removeItem("exibirComunicadoUmaVez");
            localStorage.removeItem("exibirEventoUmaVez");
            localStorage.removeItem("exibirEnqueteUmaVez");
            localStorage.removeItem("email");
            localStorage.removeItem("tokenFMC");

            $.cookie("updateTokenFCM", null);
            $.cookie("mensalidade", null);

            this.$store.dispatch('userSignOut');

            location.reload();

            this.$router.push(`/sign-in`)

        },
        goToMedicamentos(){
            // Google Analytics - Pageview
            this.$ga.event({
                eventCategory: 'menu',
                eventAction: 'clicou',
                eventLabel: 'medicamentos'//,
                //eventValue: 123
            })
            this.$router.push(`/lembrete-medicacao-listagem`)
        },
        fnAtualizar(){ // atualiza todo o aplicativo exceto o login

            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': 'menu',
                'event_label': 'atualizar'//,
                //'value': '<value>'
            });
            
            userProperties.loaded = false,
            userProperties.email = null;
            userProperties.perfil = null,
            userProperties.slug = null,
            userProperties.extensao = null,
            userProperties.nome = null,
            userProperties.escolaID = null

            localStorage.removeItem("exibirComunicadoUmaVez");
            localStorage.removeItem("exibirEventoUmaVez");
            localStorage.removeItem("exibirEnqueteUmaVez");
            localStorage.removeItem("tokenFMC");

            $.cookie("updateTokenFCM", null);
            $.cookie("mensalidade", null);

            cache.homeObj = false;

            location.reload();
        },
        closeDialog(){
            this.dialog = false;
            pushProperties.exibirPush = false;
        },
        meuPerfil(){
            // Google Analytics - Pageview
            this.$ga.event({
                eventCategory: 'menu',
                eventAction: 'clicou',
                eventLabel: 'Imagem Perfil'//,
                //eventValue: 123
            })
            this.$router.push(`/Perfil/?slug=`+this.slug)
        },
        goToMensagens(){
            // Google Analytics - Pageview
            this.$ga.event({
                eventCategory: 'header',
                eventAction: 'clicou',
                eventLabel: 'icone mensagens'//,
                //eventValue: 123
            })
            this.$router.push(`/mensagens-listagem`)
        },
        profileMenu(){
            try{
                this.setIsAuthenticated = localStorage.getItem('setIsAuthenticated');
        
                this.nome = userProperties.nome;
                this.slug = userProperties.slug;
                this.perfil = userProperties.perfil;
                if(userProperties.imagem != null){
                    var storageRef = firebase.storage().ref();
                    var tangRef = storageRef.child('profile/'+userProperties.imagem);

                    // First we sign in the user anonymously
                    //firebase.auth().signInAnonymously().then((result) => {
                    // Once the sign in completed, we get the download URL of the image
                    
                    tangRef.getDownloadURL().then(urlImgFB =>                             {
                        // Once we have the download URL, we set it to our img element
                        console.log(urlImgFB);
                        this.urlImg = urlImgFB;

                        }).catch(function(error) {
                            // If anything goes wrong while getting the download URL, log the error
                            //console.log(error);
                        });
                }
                
            }
            catch(err){

            }
            
        },
        vencimentoMensal(){
            var that = this;
            setTimeout(function(){ 
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second;

                if(day == userProperties.dataVencimentoMensal){
                    that.alertaVencimentoMensal = true;
                    that.msgVencimentoAlerta = "Sua mensalidade vence hoje!";
                }
                if(Number(day) == Number(userProperties.dataVencimentoMensal - 1)){
                    that.alertaVencimentoMensal = true;
                    that.msgVencimentoAlerta = "Sua mensalidade vence amanhã!";
                }
                if(Number(day) == Number(userProperties.dataVencimentoMensal - 2) || Number(day) == Number(userProperties.dataVencimentoMensal - 3)){
                    that.alertaVencimentoMensal = true;
                    that.msgVencimentoAlerta = "Sua mensalidade vence dia " + userProperties.dataVencimentoMensal + "!";
                }
                
            }, 15000);
            
        },
        atualizaQtdNotificacoes(){
            this.qtdNotificacoes = $.cookie("qtdNotificacoes") ;
        }
    },
    created(){

        this.vencimentoMensal();

        var that = this;
        var myInterval = setInterval(function(){
            that.profileMenu();
            that.atualizaQtdNotificacoes();
            if(userProperties.nome != null)
                clearInterval(myInterval);     
        },2000);

        var myInterval2 = setInterval(function(){
            that.vencimentoMensal();
        },900000); // 15 minutos - 15 * 60 * 1000 = 900000 (15 mins * 60 seconds per minute * 1000 milliseconds per second.) 

        // limpa o cache das postagens da home
        var myIntervalCacheHome = setInterval(function(){
            cache.home = false
        },900000); // 15 minutos - 15 * 60 * 1000 = 900000 (15 mins * 60 seconds per minute * 1000 milliseconds per second.) 
        

        //Verifica se exibe push em formato de modal - Apenas quando o app está aberto Foreground
        var myInterval2 = setInterval(function(){
            console.log("Verifica se tem push");
            if(pushProperties.exibirPush != null && pushProperties.exibirPush != false && pushProperties.title != "Comunicado!"){
                that.dialog = true;
                that.title = pushProperties.title;
                that.body = pushProperties.body;
                //clearInterval(myInterval2);

            }
            
            // atualiza quantidade de notificacoes
            that.atualizaQtdNotificacoes();

        },20000); // verifica a cada 1 minuto


        // Apenas para professores / administrativo-professores - Verifica se tem lembrete de medicação no dia atual
        setTimeout(function(){
            if(userProperties.perfil == 4 || userProperties.perfil == 5 && globalProperties.exibirAlertaMedicacao == true)
                that.exibirAlertaMedicacao = true
        }, 10000);

        var myInterval3 = setInterval(function(){
            if(userProperties.perfil == 4 || userProperties.perfil == 5 && globalProperties.exibirAlertaMedicacao == true){
                that.exibirAlertaMedicacao = true
            }
            //if(userProperties.nome != null)
                //clearInterval(myInterval3);     
        },20001000); // re-verifica a cada 3 horas e 1 segundo
        
        
        // Ajuste PWA erro na primeira abertura do app, fica com a tela em branco
        
        if (window.matchMedia('(display-mode: standalone)').matches) {// Se for web / mobile web redireciona para o site
            setTimeout(function(){
                that.$router.push(`/`)
            }, 1000);
        }
        else if (window.navigator.standalone === true) {
            setTimeout(function(){
                that.$router.push(`/`)
            }, 1000);
        }
        

        
        
    }
};

</script>

<style scoped>
a {
    color: white;
    text-decoration: none;
}

.logout{
    position: relative;
    right: -4px;
    height: auto;
}

.div-logout{
    margin-top: 15px
}

.profile{
    text-align: center;
    margin-top: -40px;
}

.img{
    width: 120px;
    height: 120px;
    margin-right: 12px;
    border:beige solid 1px;
    border-radius: 50%;
    background-position: center top;
    background-size: 100% auto;
    position: relative;
    top:-6px;
    margin-left:12px;
    border: solid 4px #fff;
    margin: 30px auto auto auto;
}

.v-alert.warning--text{
    background: #fff;
    margin: 10px;
}

a.fecharAviso{
    color: red;
    position: absolute;
    right: 0;
    top: -27px;
    color: #fff;
}

.alertaMedicacao{
    margin: 25px 0 0 0;
    float: left;
    width: 100%;
}

.alertaMedicacao img{
    width: 50px;
    height: auto;
    float: left;
}

.v-icon.material-icons{
    margin-right: 3px !important
}

.mensagens{
    width: 35px;
    height: auto;
    position: absolute;
    right: 12px;
}

.qtdMensagens{
    position: absolute;
    right: 45px;
    top: 16px;
}

.atualizar{
    margin: 10px;
}

.v-dialog button{
    border: solid 1px !important;
}

.alert-mensalidade, .alert-mensalidade *{
    color: #fff;
}

.alert-mensalidade{
    background: #f86300;
    padding: 10px;
    position: relative;
    text-align: center
}

.alert-mensalidade button{
    position: absolute;
    right: 8px;
    top: -20px
}

</style>
